import React, { useState } from 'react';
import { Button, Popover, Form, Input } from 'antd';
import { DislikeOutlined, LikeOutlined } from '@ant-design/icons';
import { FeedbackWrapper } from './styled';
import { NEXA_FEEDBACK } from '@src/utils/sensor/track';
import apptracker from '@src/utils/sensor/apptracker';
import { getSessionId } from '../NexaStore';

const CommentForm = ({ onSubmit }) => {
  const [form] = Form.useForm();

  const onFinish = ({ comment }) => {
    onSubmit(comment);
  };

  return (
    <div style={{ width: 400 }}>
      <Form initialValues={{ comment: '' }} onFinish={onFinish} form={form} name="feeback-form">
        <Form.Item
          name="comment"
          rules={[{ required: true, message: 'Please enter your feedback' }]}
        >
          <Input.TextArea showCount maxLength={150} rows={4} />
        </Form.Item>
        <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

const Feedback = ({ eventId }) => {
  const [thumb, setThumb] = useState<'up' | 'down' | null>(null);
  const [visible, setVisible] = useState(true);
  const [commentOpen, setCommentOpen] = useState(false);
  const sessionId = getSessionId();

  const onFeedbackSubmit = () => {
    setCommentOpen(false);
  };

  const handleOpenChange = (value: boolean) => {
    setCommentOpen(value);
  };

  const handleUpvote = () => {
    setThumb('up');
    apptracker(NEXA_FEEDBACK, { value: 'thumbs_up', sessionId, eventId });
    // onFeedbackSubmit();
  };

  const handleDownvote = (comment = '') => {
    setThumb('down');
    apptracker(NEXA_FEEDBACK, { value: 'thumbs_down', sessionId, eventId, comment });
    onFeedbackSubmit();
  };

  // React.useEffect(() => {
  //   if (thumb) {
  //     const timer = setTimeout(() => setVisible(false), 2500);
  //     return () => clearTimeout(timer);
  //   } else {
  //     setVisible(true);
  //   }
  // }, [thumb]);

  return (
    <FeedbackWrapper
      style={{
        opacity: visible ? 1 : 0,
        transition: 'opacity 0.5s ease',
        pointerEvents: visible ? 'auto' : 'none',
      }}
    >
      <Button
        size="small"
        icon={<LikeOutlined />}
        onClick={handleUpvote}
        aria-label="Upvote"
        type="text"
        shape="circle"
        style={thumb === 'up' ? { color: 'green' } : {}}
      />
      <Popover
        content={<CommentForm onSubmit={handleDownvote} />}
        title="Comment"
        trigger={'click'}
        placement="topRight"
        onOpenChange={handleOpenChange}
        open={commentOpen}
        destroyTooltipOnHide={true}
      >
        <Button
          size="small"
          icon={<DislikeOutlined />}
          // onClick={handleDownvote}
          aria-label="Downvote"
          type="text"
          shape="circle"
          style={thumb === 'down' ? { color: 'red' } : {}}
        />
      </Popover>
    </FeedbackWrapper>
  );
};

export default Feedback;
